<template>
    <div id="reservation-dialog" class="dialog" style="display: none">
        <div class="dialog__container mdc-elevation--z2">
            <div class="dialog__container--title">
                新增預約
            </div>

            <div class="dialog__container--description">
                這是管理員版本將會無視一切條件限制，請小心處理新預約。
            </div>

            <form id="new-reserve-form">
                <div class="input-container">
                    <div id="type-opts" class="mdc-select" data-mdc-auto-init="MDCSelect">
                        <i class="mdc-select__dropdown-icon"/>
                        <select id="table-select" class="mdc-select__native-control" name="table_id">
                            <option value="" selected/>
                            <option v-for="table in tables" :value="table.id">[{{ table.id }}]{{ table.name }}</option>
                        </select>
                        <label for="table-select" class="mdc-floating-label">優惠類別</label>
                        <div class="mdc-line-ripple"></div>
                    </div>
                </div>

                <div class="input-container">
                    <div class="config-tf mdc-text-field" data-mdc-auto-init="MDCTextField" style="width: 100%;">
                        <input type="text" id="user-auto-complete" class="mdc-text-field__input" value="" required v-on:input="autocomplete" v-model="keyword">
                        <input id="input-user-id" type="hidden" name="user_id" value=""/>
                        <label for="user-auto-complete" class="mdc-floating-label">用戶</label>
                        <div class="mdc-line-ripple"></div>
                    </div>

                    <div class="config-tf mdc-text-field" data-mdc-auto-init="MDCTextField" style="width: 100%">
                        <input type="date" id="date" name="date" class="mdc-text-field__input" value="1990-11-18" required>
                        <label for="date" class="mdc-floating-label">日期</label>
                        <div class="mdc-line-ripple"></div>
                    </div>
                </div>

                <div class="input-container">
                    <div class="config-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                        <input type="time" id="new-res-start_at" name="start_at" class="mdc-text-field__input" value="12:00" required>
                        <label for="new-res-start_at" class="mdc-floating-label">開始時間</label>
                        <div class="mdc-line-ripple"></div>
                    </div>
                    <div class="config-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                        <input type="time" id="new_res-end_at" name="end_at" class="mdc-text-field__input" value="12:59" required>
                        <label for="new_res-end_at" class="mdc-floating-label">結束時間</label>
                        <div class="mdc-line-ripple"></div>
                    </div>

                    <div class="config-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                        <input type="number" id="max_customer" name="max_customer" class="mdc-text-field__input" value="12:59" required>
                        <label for="max_customer" class="mdc-floating-label">人數</label>
                        <div class="mdc-line-ripple"></div>
                    </div>
                </div>
            </form>

            <div class="dialog__container--action">
                <button type="button" class="mdc-button" onclick="$('#reservation-dialog').hide()">取消</button>
                <button id="btn-submit-new-reserve" type="submit" class="mdc-button mdc-button--raised" v-on:click.prevent.stop="submit">儲存</button>
            </div>
        </div>

        <div class="dialog__container mdc-menu-surface--anchor">
            <div id="user-autocomplete" class="mdc-menu mdc-menu-surface" data-mdc-auto-init="MDCMenu">
                <ul class="mdc-list">
                    <li v-for="data in this.users" v-on:click.prevent="userSelector($event, data)" class="mdc-list-item">
                        <span class="mdc-list-item__text">[{{ data.name }}] {{ data.censor_mail }} </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {Corner} from '@material/menu'
    export default {
        props: {
            store: {
                required: true
            }
        },
        data() {
            return {
                tables: [],
                users: [],
                keyword: '',
                tableUrl: `/popsale/api/v1/res/store/${this.store}/tables`
            }
        },
        methods: {
            fetchTable() {
                popsale.formRequest(this.tableUrl, 'get', null, function (response) {
                    this.tables = response.data;
                }.bind(this));
            },
            autocomplete(event) {
                console.log(this.keyword);
                let url = `/popsale/api/v1/users/search?keyword=${this.keyword}`;

                popsale.formRequest(url, 'get', null, function (response) {
                    $('#user-autocomplete')[0].MDCMenu.open = response.length > 0;
                    this.users = response;
                }.bind(this));
            },
            userSelector(event, item) {
                $('input#input-user-id').val(item.id);
                $('input#user-auto-complete').val(item.name);
            },
            submit() {
                let data = new FormData($('#new-reserve-form')[0]);
                let url = `/popsale/api/v1/res/store/${this.store}/table/${data.get('table_id')}/reserve`;

                popsale.formRequest(url, 'post', data, function () {
                    popsale.snackText("建立成功");
                });
            },
        },
        mounted() {
            this.$nextTick(function () {
                window.mdc.autoInit();
                $('#user-autocomplete.mdc-menu')[0].MDCMenu.setAnchorCorner(Corner.BOTTOM_START);
            }.bind(this));

            this.fetchTable();
        }
    }
</script>

<style lang="scss">
    #reservation-dialog.dialog {
        flex-direction: column;
    }

    #user-autocomplete.mdc-menu.mdc-menu-surface {
        position: unset;
        width: 100%;
    }
</style>